export const locale = {
  admin_impersonation: 'Admin impersonating {{first_name}} {{last_name}}',
  end: 'END',
};
